import { RECOMMANDER_BUCKET_LABELS, RECOMMANDER_BUCKET_SLUGS } from '@mtg-deck-tool/shared';
import { useSearchStore } from '../../stores/search-store.js';
import { useBarClause } from '../../hooks/useBarClause.js';

export function ActiveFiltersChips() {
  const activeTagSlugs = useSearchStore((s) => s.activeTagSlugs);
  const activeRecBucket = useSearchStore((s) => s.activeRecBucket);
  const toggleTagFilter = useSearchStore((s) => s.toggleTagFilter);
  const toggleRecBucket = useSearchStore((s) => s.toggleRecBucket);
  const filters = useSearchStore((s) => s.filters);
  const setFilters = useSearchStore((s) => s.setFilters);
  const { writeClause } = useBarClause();

  const hasAnyFilter =
    activeTagSlugs.length > 0 ||
    activeRecBucket !== null ||
    Object.values(filters).some((v) => v !== undefined && v !== '');

  if (!hasAnyFilter) return null;

  const chipBase = 'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium';
  const removableChip = `${chipBase} bg-gray-700 text-gray-300 border border-gray-600`;

  const removeFilter = (key: string, prefix: string) => {
    setFilters({ [key]: undefined });
    writeClause(prefix, null);
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {/* Active tags (removable) */}
      {activeTagSlugs.map((slug) => (
        <button
          key={slug}
          onClick={() => toggleTagFilter(slug, true)}
          className={`${removableChip} text-orange-300 border-orange-800/60 bg-orange-950/40`}
        >
          otag:{slug}
          <span className="ml-0.5 opacity-60 hover:opacity-100">✕</span>
        </button>
      ))}

      {/* Active recommander bucket */}
      {activeRecBucket && (
        <button
          onClick={() => toggleRecBucket(activeRecBucket)}
          className={`${removableChip} text-amber-300 border-amber-800/60 bg-amber-950/40`}
          title={`Recommander: ${RECOMMANDER_BUCKET_LABELS[activeRecBucket]}`}
        >
          rectag:{RECOMMANDER_BUCKET_SLUGS[activeRecBucket]}
          <span className="ml-0.5 opacity-60 hover:opacity-100">✕</span>
        </button>
      )}

      {/* Quick filter chips */}
      {filters.type && (
        <button onClick={() => removeFilter('type', 'type:')} className={removableChip}>
          type:{filters.type} <span className="ml-0.5 opacity-60">✕</span>
        </button>
      )}
      {filters.rarity && (
        <button onClick={() => removeFilter('rarity', 'r:')} className={removableChip}>
          r:{filters.rarity} <span className="ml-0.5 opacity-60">✕</span>
        </button>
      )}
      {filters.maxPrice !== undefined && (
        <button onClick={() => removeFilter('maxPrice', 'usd<=')} className={removableChip}>
          usd≤{filters.maxPrice} <span className="ml-0.5 opacity-60">✕</span>
        </button>
      )}
    </div>
  );
}
